import { style } from "@material-ui/system";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  textfield: {
    margin: "8px auto",
    width: "100%"
  },
  toolbar: {
    margin: "4px"
  },
  bigAvatar: {
    width: 100,
    height: 100,
    margin: "auto"
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(2, 0, 2, 0)
  }
});

export default { styles };
